import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import SystemLayers from './SystemLayers';
import ExternalLayers from './ExternalLayers';
import Basemaps from './Basemaps';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box b={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: 'rgba(36, 97, 142, 1)',
      color: "#fff !important"
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
      padding: '5px 15px',
      lineHeight: 'normal',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      marginBottom: '15px',
      boxShadow: 'none',
      background: '#fff',
      borderBottom: '1px solid #24618E',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '8px 8px 0px 0px',
        minHeight: 'auto',
        color: '#333',
        textTransform: 'capitalize',
        borderBottom: 'none',
      },
    },
    '& h5': {
      fontSize: '18px',
      margin: '0px 0 10px',
    },
    '& .MuiAppBar-root': {
      marginBottom: '0px !important'
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    }
  },
  layerBlock: {
    '& h4': {
      fontSize: '20px',
      margin: '10px 0',
    },
  }
}));
//End Css code ...

//Start Tabo component code ...
const Tabo = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const catchAllStationsFromSyatemLayer = (data) => {
    props.callTabo(data);
  }

  return (
    <React.Fragment>
      <div className={classes.layerBlock}>
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="System Layers" {...a11yProps(0)} />
              {/* <Tab label="External Layers" {...a11yProps(1)} /> */}
              
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}>
              <SystemLayers
                callSystemLayer={catchAllStationsFromSyatemLayer}
                geojsonNF={props.geojsonNF}
                ShowAllStations={props.ShowAllStations}
                loaderOff={props.loaderOff}
                loaderFunction={props.loaderFunction}
                loadSource = {props.loadSource}
                checked={props.checked}
              />
            </TabPanel>
            {/* <TabPanel value={value} index={1} dir={theme.direction}>
              <ExternalLayers />
            </TabPanel> */}
            
          </SwipeableViews>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Tabo;
//Start Tabo component code ...
